export const THEME = {
    SYSTEM: 'system',
    LIGHT: 'light',
    DARK: 'dark',
} as const;

export type Theme = (typeof THEME)[keyof typeof THEME];

export const THEME_OPTIONS = [
    { id: THEME.SYSTEM, label: 'Device' },
    { id: THEME.LIGHT, label: 'Light' },
    { id: THEME.DARK, label: 'Dark' },
] as const;

export type ThemeOption = (typeof THEME_OPTIONS)[number];
